import React from 'react';
const AdminContacts = () => <div className="min-h-screen p-8">Admin Contacts Management</div>;
export default AdminContacts; 